import React, { Component } from 'react';
import TestimonialsAPI from '../api/testimonialsAPI';
import Pagination from '../base/pagination';
import {actions, Loader, SelectField} from 'react-fields';
import NotFound from '../careers/notFound';
import ScrollToTop from '../ScrollToTop/index';
import PaginationMeta from '../paginationMeta';

import Testimonial from "./testimonial";

const FILTERS = [{value: 'all', label: 'All testimonials'},
    {value: 'career', label: 'Career match'},
    {value: 'industry', label: 'Career interests test'},
    {value: 'personality', label: 'Work personality test'},
    {value: 'motivator', label: ' Career motivators test'},
    {value: 'numerical', label: 'Numerical reasoning test'},
    {value: 'abstract', label: 'Abstract reasoning test'},
    {value: 'verbal', label: 'Verbal reasoning test'}];

class Index extends Component {

   state = {
            items: this.props.initialParams.items || [],
            page: this.props.initialParams && this.props.initialParams.page ? parseInt(this.props.initialParams.page) : 1,
            totalPages: this.props.initialParams ? this.props.initialParams.total_pages : 1,
            total: this.props.initialParams ? this.props.initialParams.total_count : 1,
            isLoading: false,
            filterBy: this.props.initialParams.filter || 'all',
            rendered: false
        };
   contentRef = React.createRef();


    loadCollection = async (options = {}) => {
        let items = [];
        let totalPages = 0;
        let total = 0;
        await TestimonialsAPI.search(options)
            .then( (result) => {
                items = result.items;
                totalPages = result.total_pages;
                total = result.total_count;
            }).catch((error) => {
                console.log(error);
            });
        return [items, totalPages, total];
    };

    onChangeField = (e) => {
        let filterBy = e.target.value;
        this.setState({filterBy: filterBy}, () => {
            this.runSearch();
        });
    }

    goToPage = (e, page) => {
        e.preventDefault();
        let options = {...this.prepareOptionsSearch(), page: page};
        this.runSearch(options, page);
        window.scrollTo({top: this.contentRef.current.offsetTop - 180, behavior: 'smooth'});
    };

    runSearch = (options = this.prepareOptionsSearch(), page = 1) => {
        let _this = this;
        this.setState({page: page, options: options, isLoading: true}, () => {
            _this.loadCollection(options).then(([items, totalPages, total]) => {
                _this.setState({items: items, isLoading: false, totalPages: totalPages, total: total});
                PaginationMeta.update({...options, page: page}, total, totalPages, 12, true);
            })
        })
    };

    prepareOptionsSearch = () => {
        let options = {page: 1};
        if (this.state.filterBy !== 'all') {
            options['filter'] = this.state.filterBy;
        }
        return options;
    };

    render(){
        return (
            <React.Fragment>

                <div className={'grid-x'}>
                    <div className={'cell'}>
                        <div className="testimonials__all">
                            <p>{this.state.total} results</p>
                            <SelectField name='filter' selected={this.state.filterBy}
                                         options={FILTERS} optionsValue='value' optionsLabel='label'
                                         onChange={this.onChangeField}
                                         className='label-icon-right select-label select-label--min-width dark'  />
                        </div>
                    </div>
                    {/*<div className={'cell medium-4 flex-end'}>*/}
                            {/*<SelectField name='filter' selected={this.state.filterBy}*/}
                                         {/*options={FILTERS} optionsValue='value' optionsLabel='label'*/}
                                         {/*onChange={this.onChangeField}*/}
                                         {/*className='label-icon-right select-label min-width-230'  />*/}
                    {/*</div>*/}
                </div>
                <div ref={this.contentRef}>
                    {this.state.isLoading ? <Loader size={'small'}/> : null}
                    {!this.state.isLoading && this.state.items.length === 0 ? <NotFound/> :
                        this.state.items && this.state.items.length > 0 ?
                            <React.Fragment>
                                <div className="grid-x testimonials__results">
                                    {this.state.items.map((item, i) => {
                                        return <div className="large-4 medium-6 small-12 cell" key={`testimonial_${i}`}>
                                            <Testimonial item={item} class={'testimonials__box--uneven'} />
                                        </div>
                                    })}
                                </div>
                                <div className="hide-for-large">
                                    <ScrollToTop/>
                                </div>
                                <Pagination page={this.state.page} options={this.prepareOptionsSearch()} path={this.props.path}
                                            totalPages={this.state.totalPages}
                                            goToPage={this.goToPage}/>
                            </React.Fragment> : null
                    }
                </div>
            </React.Fragment>
        )
    }
}

export default Index;